import { useEffect, useMemo } from 'react';

import ProgressBar from '@badrap/bar-of-progress';
import { useFetchers, useNavigation } from 'react-router';

export const NavigationProgressBar = ({
  options,
}: {
  options?: ConstructorParameters<typeof ProgressBar>[0];
}) => {
  const progress = useMemo(() => new ProgressBar(options), []);

  const { state } = useNavigation();
  let fetchers = useFetchers();

  let transitionState = useMemo<'idle' | 'loading'>(
    function getGlobalState() {
      let states = [state, ...fetchers.map((fetcher) => fetcher.state)];
      if (states.every((state) => state === 'idle')) return 'idle';
      return 'loading';
    },
    [state, fetchers]
  );

  useEffect(() => {
    if (transitionState == 'loading') {
      progress.start();
    }
    if (transitionState == 'idle') {
      setTimeout(() => {
        progress.finish();
      }, 10);
    }
  }, [progress, transitionState]);

  return null;
};
